
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ameegos/trip",
      function () {
        return require("private-next-pages/ameegos/trip.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ameegos/trip"])
      });
    }
  